export function createActionEvent(params) {
  return typeof params === 'string' ? { event: 'action', id: params } : { event: 'action', ...params };
}
